/* eslint-disable complexity */
import { defineStore } from "pinia";
import { Lifestyle } from "../entities/quote";
import {
    LifestyleInformationWithSmoking,
    aboutLifeStyleInformation, aboutLifeStyleInformationPartial,
} from "../composables/aboutYou";
import { MedicalCondition } from "../entities/conditions";

export enum SmokerStatus {
    Never,
    Previously,
    Currently,
}

export enum MeasurementUnitType {
    Metric = "metric",
    Imperial = "imperial"
}

export enum MeasurementUnitLength {
    Centimetres = "cm",
    Inches = "in",
    Feet = "ft"
}

export enum MeasurementUnitWeight {
    Stone = "st",
    Pounds = "lbs",
    Kilogram = "kg"
}

export type AboutYouStore = {
    smoker: SmokerStatus | null,
    smokingStart: string,
    smokingEnd: string,
    cigarettes: boolean | null,
    cigarettesPerDay: number | null,
    cigars: boolean | null,
    cigarsPerDay: number | null,
    rollingTobacco: boolean | null,
    rollingTobaccoPerWeek: number | null,
    pipeTobacco: boolean | null,
    pipeTobaccoPerWeek: number | null,
    alcohol: number | null,
    heightFeet: number | null,
    heightInches: number | null,
    heightCentimetres: number | null,
    heightUnit: MeasurementUnitType,
    weightStone: number | null,
    weightPounds: number | null,
    weightKg: number | null,
    weightUnit: MeasurementUnitType,
    waistInches: number | null,
    waistCentimetres: number | null,
    waistUnit: MeasurementUnitType,
    medical: boolean | null,
    selectedMedicalConditions: MedicalCondition[],
    currentMedicalCondition: MedicalCondition | null,
    toggleAlcoholModal: boolean,
}

export const useAboutYouStore = defineStore("aboutYou", {
    state: () : AboutYouStore => {
        return {
            smoker: null,
            smokingStart: "",
            smokingEnd: "",
            cigarettes: null,
            cigarettesPerDay: null,
            cigars: null,
            cigarsPerDay: null,
            rollingTobacco: null,
            rollingTobaccoPerWeek: null,
            pipeTobacco: null,
            pipeTobaccoPerWeek: null,
            alcohol: null,
            heightFeet: null,
            heightInches: null,
            heightCentimetres: null,
            heightUnit: MeasurementUnitType.Imperial,
            weightStone: null,
            weightPounds: null,
            weightKg: null,
            weightUnit: MeasurementUnitType.Imperial,
            waistInches: null,
            waistCentimetres: null,
            waistUnit: MeasurementUnitType.Imperial,
            medical: null,
            selectedMedicalConditions: [],
            currentMedicalCondition: null,
            toggleAlcoholModal: false,
        };
    },
    getters: {
        getLifeStyleInformation: (state): Lifestyle => aboutLifeStyleInformation(state),
        getLifeStyleInformationForPartial: (state):
            Partial<LifestyleInformationWithSmoking> => aboutLifeStyleInformationPartial(state),
        getMedicalConditions: (state) => {
            return state.selectedMedicalConditions;
        },
        getFormattedMedicalConditions: (state) => { return state.selectedMedicalConditions; },
    },
});
